<div
	class="grid gap-4"
	[class]="
		client_()?.employmentStatus?.employmentStatus ===
		employmentStatusEnum.EMPLOYED
			? 'grid-cols-3'
			: 'grid-cols-2'
	"
>
	<div>
		<app-select
			label="Employment status"
			[ngModel]="form.employmentStatus"
			(ngModelChange)="updateEmploymentStatus($event, 'employmentStatus')"
		>
			@for (item of employmentStatusOptions; track $index) {
				<option
					[value]="item.value"
					[testHook]="testHooks.EmploymentStatusOptions"
				>
					{{ item.name }}
				</option>
			}
		</app-select>
	</div>
	@if (
		client_()?.employmentStatus?.employmentStatus === employmentStatusEnum.OTHER
	) {
		<div>
			<app-input
				label="Please Specify"
				[ngModel]="form.employmentOther"
				(debounce)="updateEmploymentStatus($event, 'employmentOther')"
				[testHook]="testHooks.EmploymentOther"
			></app-input>
		</div>
	}

	@if (
		client_()?.employmentStatus?.employmentStatus ===
		employmentStatusEnum.EMPLOYED
	) {
		<div>
			<app-input
				label="Occupation"
				[ngModel]="form.employmentOccupation"
				(debounce)="updateEmploymentStatus($event, 'employmentOccupation')"
				[testHook]="testHooks.EmploymentOccupation"
			></app-input>
		</div>
		<div>
			<app-input
				label="Company"
				[ngModel]="form.employmentCompany"
				(debounce)="updateEmploymentStatus($event, 'employmentCompany')"
				[testHook]="testHooks.EmploymentCompany"
			></app-input>
		</div>
	}
</div>

@if (
	client_()?.employmentStatus?.employmentStatus ===
	employmentStatusEnum.EMPLOYED
) {
	<div class="mt-6">
		<div>
			<h4 class="text-lg font-medium">Employer Address</h4>
		</div>

		<div class="grid grid-cols-3 gap-4">
			<div>
				<app-input
					label="Street"
					[ngModel]="address_().street"
					(debounce)="updateEmploymentAddress($event, 'street')"
					[testHook]="testHooks.Street"
				></app-input>
			</div>
			<div>
				<app-input
					label="Unit"
					[ngModel]="address_().unit"
					(debounce)="updateEmploymentAddress($event, 'unit')"
					[testHook]="testHooks.Unit"
				></app-input>
			</div>
			<div>
				<app-input
					label="PO Box"
					[ngModel]="address_().poBox"
					(debounce)="updateEmploymentAddress($event, 'poBox')"
					[testHook]="testHooks.PoBox"
				></app-input>
			</div>
			<div>
				<app-input
					label="City"
					[ngModel]="address_().city"
					(debounce)="updateEmploymentAddress($event, 'city')"
					[testHook]="testHooks.City"
				></app-input>
			</div>
			<div>
				<app-input
					label="Postal Code"
					[ngModel]="address_().postcode"
					(debounce)="updateEmploymentAddress($event, 'postcode')"
					[testHook]="testHooks.PostalCode"
				></app-input>
			</div>
			<div>
				<app-input
					label="Province/territory"
					[ngModel]="address_().province"
					(debounce)="updateEmploymentAddress($event, 'province')"
					[testHook]="testHooks.Input"
				></app-input>
			</div>
			<div>
				<app-input
					label="Country"
					[ngModel]="address_().country"
					(debounce)="updateEmploymentAddress($event, 'country')"
					[testHook]="testHooks.Country"
				></app-input>
			</div>
		</div>
	</div>
}
